export const copilotkitRuntimeUrl = process.env.REACT_APP_PUBLIC_API_URL
  ? `${process.env.REACT_APP_PUBLIC_API_URL}/copilotkit`
  : undefined;
